define('NVT.AnnualApplicationFormE.GlobalformUploadFile.View'
, [
      'Backbone'

    , 'nvt_mulitple_upload_dynemic.tpl'

    , 'Backbone.FormView'

    , 'GlobalViews.Message.View'

    , 'underscore'

    , 'jQuery'

    , 'Utils'    
  ]
, function
  (
        
    Backbone

    , nvt_mulitple_upload_dynemic_tpl

    , BackboneFormView

    , MessageView

    , _

    , jQuery

    , Utils    

  )
{
  'use strict';

    return Backbone.View.extend({
           
        template: nvt_mulitple_upload_dynemic_tpl

    ,   title: Utils.translate('Multiple File Upload')

    ,   initialize: function(options)
        {
            this.options = options;
            this.application = options.application;
            this.page_header = "Multiple File Upload";	
            this.modalClass ='modal-md modal_md_custom';  
            var self = this;
            BackboneFormView.add(this);
        }

    ,   events: 
        {
            'submit form': 'saveTheForm'
        }   
        
    ,   saveTheForm: function(e)
        {
            e.preventDefault();
            e.stopImmediatePropagation();

            var self = this,
                $target = jQuery(e.target),
                getfielddata = $target.serializeObject();
                
            if(!getfielddata.hd_mulitplefileup)
            {
                self.showMessage('File is required', 'error','mulitplefileup');
                return false;
            }
            else
            {
                var splitDataArr = getfielddata.hd_mulitplefileup.split(",");
                for (let [i, muf] of self.options.globalmultipleuploadfilelist.entries()) {
                    if (muf.global_fileName === splitDataArr[2]) {
                        self.options.globalmultipleuploadfilelist.splice(i, 1);
                    }
                }
                
                var getCurrentFileDetails = {
                    'id':new Date().getTime(),
                    'global_fileName':splitDataArr[2],
                    'global_filetype':splitDataArr[3],
                    'global_filesize':  (splitDataArr[4] / (1024*1024)).toFixed(2) + ' MB',
                    'global_filedetails':getfielddata.hd_mulitplefileup,
                    'getfileId':self.options.getfileId,
                    'folderlocfile' : SC.CONFIGURATION.AnnualApplicationFormE.config,
                }
              
                self.options.globalmultipleuploadfilelist.push(getCurrentFileDetails);
                var promise = BackboneFormView.saveForm.apply(this,arguments);
            }                             
        }

    ,   showMessage: function(message, type, field)
        {
            jQuery('.global-views-message-error').remove(); 
            jQuery('.global-views-message-success').remove(); 

            var messageView = new MessageView
            ({
                    message: message
                ,   type: type
                ,   closable: type =='error' ? true : false
            });
            if (typeof field !== 'undefined')
            {
                this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
            }
            else if (type =='error'){
                this.application.getLayout().$('form').append(messageView.render().$el);
            }
            else
            {
                this.application.getLayout().$('form').empty().html(messageView.render().$el);       
                setTimeout(function() {
                    jQuery("[data-dismiss=modal]").trigger({ type: "click" });
                }, 1000);
            }
        }    

    ,   getContext: function() {

            return {
        
                title : this.title
            }
        }        

    });

});
